import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';

const RadioCell = (props) => {
    const {
        id,
        inputName,
        legendName,
        initialValue,
        onChangeCb,
    } = props;

    const [ value, setValue ] = useState(Number(initialValue));

    const onChangeHandler = (value) => {
        setValue(value);
        onChangeCb(value);
    };

    return (
        <form className="usa-form">
            <fieldset className="usa-fieldset">
                <legend className="usa-sr-only">{legendName}</legend>
                <div className="usa-radio">
                    <input
                        className="usa-radio__input"
                        id={`${id}${inputName}False`}
                        type="radio"
                        checked={value===0}
                        name={inputName}
                        onChange={() => onChangeHandler(0)}
                    />
                    <label className="usa-radio__label" htmlFor={`${id}${inputName}False`}><FormattedMessage id="label.no"/></label>
                </div>
                <div className="usa-radio">
                    <input
                        className="usa-radio__input"
                        id={`${id}${inputName}True`}
                        type="radio"
                        checked={value===1}
                        name={inputName}
                        onChange={() => onChangeHandler(1)}
                    />
                    <label className="usa-radio__label" htmlFor={`${id}${inputName}True`}><FormattedMessage id="label.yes"/></label>
                </div>
            </fieldset>
        </form>
    );
};

export default RadioCell;